



















import { Component, Vue } from "vue-property-decorator";
import LegalRiskTerms from "./LegalRiskTerms.vue";
import { LegalRiskState } from "../../utils/enum";

@Component({
  components: {
    LegalRiskTerms
  }
})
class LegalRiskRejectedGuard extends Vue {
  content = require("../../assets/docs/legal_risk_en.md");

  handleRetry() {
    this.$store.commit("app/SET_LEGAL_RISK_STATE", LegalRiskState.NONE);
  }
}
export default LegalRiskRejectedGuard;
